import { render, staticRenderFns } from "./TagsGroupsItem.vue?vue&type=template&id=13a95b39&scoped=true&"
import script from "./TagsGroupsItem.vue?vue&type=script&lang=js&"
export * from "./TagsGroupsItem.vue?vue&type=script&lang=js&"
import style0 from "./TagsGroupsItem.vue?vue&type=style&index=0&id=13a95b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a95b39",
  null
  
)

/* custom blocks */
import block0 from "./TagsGroupsItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports